/* eslint-disable no-underscore-dangle */

import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Grid from '../../Grid'

const PageOption = ({ option, index, handleChange, driveMapping }) => {
  const namePrefix = `page_option_type[page_options_attributes][${index}]`
  const [pageOption, setPageOption] = useState(option)

  useEffect(() => {
    handleChange(pageOption, index)
  }, [pageOption])

  const fields = () => {
    if (driveMapping) {
      return (
        <>
          <Grid item xs={5}>
            Drive
            <input
              type="text"
              className="form-control"
              name={`${namePrefix}[name]`}
              value={pageOption.name}
              onChange={(event) => setPageOption((prevState) => ({ ...prevState, name: event.target.value }))}
            />
          </Grid>

          <Grid item xs={5}>
            Year
            <input
              type="text"
              className="form-control"
              name={`${namePrefix}[year]`}
              value={pageOption.year}
              onChange={(event) => setPageOption((prevState) => ({ ...prevState, year: event.target.value }))}
            />
          </Grid>

          <Grid item xs={2}>
            <input
              type="checkbox"
              name={`${namePrefix}[_destroy]`}
              value={pageOption._destroy}
              checked={pageOption._destroy}
              onChange={(event) => setPageOption({ _destroy: event.target.checked })}
            />
            Delete?
          </Grid>
        </>
      )
    }

    return (
      <>
        <Grid item xs={10}>
          <input
            type="text"
            className="form-control"
            name={`${namePrefix}[name]`}
            value={pageOption.name}
            onChange={(event) => setPageOption({ name: event.target.value })}
          />
        </Grid>
        <Grid item xs={2}>
          <input
            type="checkbox"
            name={`${namePrefix}[_destroy]`}
            value={pageOption._destroy}
            checked={pageOption._destroy}
            onChange={(event) => setPageOption({ _destroy: event.target.checked })}
          />
          Delete?
        </Grid>
      </>
    )
  }

  return (
    <>
      {`Option ${index + 1}`}
      <input name={(index !== null) && `${namePrefix}[id]`} value={pageOption.id} readOnly hidden />
      <Grid container xs={12} spacing={2}>
        {fields()}

      </Grid>
    </>
  )
}

PageOption.propTypes = {
  option: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    _destroy: PropTypes.bool,
  }),
  index: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
}

PageOption.defaultProps = {
  option: { id: null, name: '', _destroy: false },
}

const PageOptionsForm = ({ pageOptions, driveMapping }) => {
  const [options, setOptions] = useState(pageOptions)

  const addOption = () => {
    setOptions((prevState) => {
      prevState.push({ name: '' })
      return [...prevState]
    })
  }

  const handleOptionChange = (item, index) => {
    setOptions((prevState) => {
      const newState = prevState
      newState[index] = item
      return [...newState]
    })
  }

  return (
    <>
      <h5>Options</h5>
      <Grid container xs={12}>
        {options.map((option, index) => (
          <Grid item xs={12} md={8}>
            <PageOption option={option} index={index} handleChange={handleOptionChange} driveMapping={driveMapping} />
            <br />
          </Grid>
        ))}
      </Grid>
      <button type="button" className="btn btn-info" onClick={addOption}>Add Option</button>
    </>
  )
}

PageOptionsForm.propTypes = {
  pageOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      year: PropTypes.string,
      _destroy: PropTypes.bool,
    }),
  ),
}

PageOptionsForm.defaultProps = {
  driveMapping: false,
  pageOptions: [],
}

export default PageOptionsForm
